import { render, staticRenderFns } from "./StructureView.vue?vue&type=template&id=b5b343ba&scoped=true&"
import script from "./StructureView.vue?vue&type=script&lang=js&"
export * from "./StructureView.vue?vue&type=script&lang=js&"
import style0 from "./StructureView.vue?vue&type=style&index=0&id=b5b343ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b343ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VAlert,VContainer,VSheet})
